import React, { FC, useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDesktop } from '$hooks';
import { Viewer } from '$shared/components';
import { MediaViewerProps } from './MediaViewer.interface';
import { attachmentsToViewerItems } from '$utils';

export const MediaViewerComponent: FC<MediaViewerProps> = ({
  attachments,
  viewItems,
  startFrom = 0,
  decryptKey,
  onClose,
  active = true,
}) => {
  const isDesktop = useDesktop();
  const [currentViewerItem, setCurrentViewerItem] = useState(startFrom);

  useEffect(() => {
    if (active) {
      setCurrentViewerItem(startFrom);
    }
  }, [active]);

  const items = useMemo(() => {
    return (
      viewItems ||
      (attachments?.length ? attachmentsToViewerItems(attachments, decryptKey || '') : [])
    );
  }, [attachments, viewItems, decryptKey]);

  return active ? (
    <Viewer
      items={items}
      active={currentViewerItem || 0}
      onChange={setCurrentViewerItem}
      onClose={onClose}
      mobile={!isDesktop}
    />
  ) : null;
};

export const MediaViewer: FC<MediaViewerProps> = (props) => {
  if (props.attachments?.length === 0) {
    return null;
  }

  const elem = document.getElementById('media-viewer-portal');
  return createPortal(<MediaViewerComponent {...props} />, elem!);
};
